export default __webpack_public_path__ + "static/media/Profile.a49d7d6f.svg";